import React from "react";
import {
  MDBContainer,
  MDBInput,
  MDBCol,
  MDBRow,
  MDBCheckbox,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from "mdb-react-ui-kit";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";

export class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showLoginModal: props.showLoginModal,
      username: "",
      password: "",
      showPassword: false,
      loginError: "",
    };
  }

  handleChange = (event) => {
    let newVal = {};
    newVal[event.target.id] = event.target.value;
    if (this.state.loginError) newVal.loginError = "";
    this.setState(newVal);
  };

  doLogin = (event) => {
    event.preventDefault();
    this.setState({ loginError: "" });

    const base64Credentials = btoa(
      this.state.username + ":" + this.state.password
    );

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Basic " + base64Credentials,
        "Content-Type": "application/json",
        "X-App-Code": this.props.appCode || "",
      },
    };

    this.props.onLoading(true);

    doFetch("SSO", "login", requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data && data.STATE === "SUCCESS") {
          this.props.onLoggedIn(data);
        } else {
          const msg =
            (data && data.MESSAGE) ||
            "Credenciales incorrectas. Inténtalo de nuevo.";
          this.setState({ loginError: msg });
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
        this.setState({ loginError: "No se pudo conectar con el servidor." });
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  };

  setShow(event) {
    if (this.state.showLoginModal !== event) {
      if (!event) {
        this.props.onCloseModal();
      }
    }
  }

  render() {
    return (
      <>
        <MDBModal show={this.state.showLoginModal} setShow={(event) => this.setShow(event)} tabIndex="-1">
          <MDBModalDialog>
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>Login</MDBModalTitle>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={() => this.setShow(false)}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <MDBContainer breakpoint="sm">
                  <form onSubmit={this.doLogin}>
                    <MDBInput
                      className="mb-4"
                      type="text"
                      id="username"
                      label="Usuario"
                      value={this.state.username}
                      onChange={this.handleChange}
                    />
                    <MDBInput
                      className="mb-4"
                      type={this.state.showPassword ? "text" : "password"}
                      id="password"
                      label="Contraseña"
                      value={this.state.password}
                      onChange={this.handleChange}
                    />
                    <div className="d-flex justify-content-end mb-3">
                      <MDBBtn
                        type="button"
                        color="link"
                        className="p-0 text-decoration-none"
                        onClick={() =>
                          this.setState((prev) => ({
                            showPassword: !prev.showPassword,
                          }))
                        }
                      >
                        <MDBIcon
                          fas
                          icon={this.state.showPassword ? "eye-slash" : "eye"}
                          className="me-1"
                        />
                        {this.state.showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                      </MDBBtn>
                    </div>

                    <MDBRow className="mb-4">
                      <MDBCol className="d-flex justify-content-center">
                        <MDBCheckbox
                          id="form1Example3"
                          label="Recordarme"
                          defaultChecked
                        />
                      </MDBCol>
                      <MDBCol>
                        <a href="/forgot-password" onClick={() => this.setShow(false)}>Recordar contraseña</a>
                      </MDBCol>
                    </MDBRow>

                    {this.state.loginError && (
                      <div className="alert alert-danger py-2 mb-3" role="alert">
                        {this.state.loginError}
                      </div>
                    )}

                    <MDBBtn type="submit" block>
                      Sign in
                    </MDBBtn>
                  </form>
                </MDBContainer>
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </>
    );
  }
}
